import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import styled from 'styled-components';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import IngredientsApi from '../../../../services/api/IngredientsApi';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import ButtonComponent from '../../../../components/common/forms/Button/ButtonComponent';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import BorderlessButton from '../../../../components/common/forms/Button/BorderlessButton';

const validationSchema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
});

export default function IngredientEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState(null);
  const history = useHistory();

  const getItem = async () => {
    const res = await IngredientsApi.get(id);
    setItemData(res.data);
  };
  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const result = await IngredientsApi.update(id, values);
    if (result.status === StatusCodes.OK) {
      history.push('/ingredients');
    } else {
      setSubmitting(false);
    }
  };

  const onDelete = async () => {
    const result = await IngredientsApi.delete(id);
    if (result.status === StatusCodes.OK) {
      history.push('/ingredients');
    }
  };

  useEffect(() => {
    getItem(id);
  }, []);

  return (
    <WhitePad>
      <TitleComponent
        title="Edit Ingredient"
        onLeftHandler={() => {
          history.goBack();
        }}
      />
      {itemData !== null ? (
        <Formik
          initialValues={{
            name: itemData.name,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '440px' }}>
              <FormRow>
                <TextInputComponent
                  label="Name"
                  name="name"
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </FormRow>
              <ActionWrapper>
                <PrimaryButton variant="primary" isSubmitting={isSubmitting} type="submit" title="Save" />
                <BorderlessButton variant="danger" size="sm" onClick={onDelete} type="submit" title="Delete" />
              </ActionWrapper>
            </form>
          )}
        </Formik>
      ) : null}
    </WhitePad>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
